import { useState, useEffect, useContext } from "react";
import { Activity_log_func } from "../../../api/activity_log/activity_log_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Tooltip, Card } from "@fluentui/react-components";
import { Info20Regular, GroupList20Regular, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, Info20Filled, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { ToastComponent } from "../../../components/toast/toast.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { FileDownloadComponent } from "../../../components/fileExport/file.export.component";
import { buttonContent, DynamicBoxingCSS, SubSectionResponsive, lightTheme, messageTheme, overflowDivider, parentHome, primaryIcon, secondaryIcon, wraperStyle, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../../styles/customStyles";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { DevicesPages } from "../../../components/side_menu/InlineSidenav";

export const Activity_log = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isRefresh, setRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [overlayData, setOverlayData] = useState<any>(false);
  const [activityExportData, setActivityExportData] = useState<any>('No data available');
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [isfilter, setIsFilter] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<String>('');
  const [activity, setActivity]: any = useState('{}');
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [uniqueModule, setUniqueModule] = useState<string[]>([]);
  const [uniqueAction, setUniqueAction] = useState<string[]>([]);
  const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);

  // Options for each filter category
  const [createdByOptions, setCreatedByOptions] = useState<any[]>([]);
  const [moduleOptions, setModuleOptions] = useState<any[]>([]);
  const [actionOptions, setActionOptions] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);

  useEffect(() => {
    setCreatedByOptions(uniqueCreatedBy?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setModuleOptions(uniqueModule?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setActionOptions(uniqueAction?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setStatusOptions(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
  }, [uniqueCreatedBy, uniqueModule, uniqueAction, uniqueStatus]);

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    // if(value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
    // }
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
  }
  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setDropDownValue1('');
    setDropDownValue2('');
  }

  const handle = useFullScreenHandle();

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9 ]*$/;
    const regexN = /^[0-9]*$/;
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      console.log("*****************************")
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
    if (name === 'filter' && dropDownValue1 === ("Activity")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  //data table column name code starts here
  var columns = [
    { key: "date", label: <Body1Strong> Date (UTC)</Body1Strong> },
    { key: "date_timezoned",
      label: <>
        <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
          <StackItem>
            <Body1Strong>&nbsp;&nbsp;Date</Body1Strong>
          </StackItem>
          <StackItem align="center">
            <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
              <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
            </Tooltip>
          </StackItem>
        </Stack>
      </>
    },
    { key: "page", label: <Body1Strong> Module </Body1Strong> },
    // { key: "os", label: <Body1Strong> Scope </Body1Strong> },
    { key: "activity", label: <Body1Strong> Activity </Body1Strong> },
    { key: "initiated_by", label: <Body1Strong> Initiated by </Body1Strong> },
    { key: "action", label: <Body1Strong> Action </Body1Strong> },
    { key: "status", label: <Body1Strong> Status </Body1Strong> },
  ];
  //data table column name code ends here
  //data table for filter
  var columns1 = [
    { key: "date", label: <Caption1> Date </Caption1> },
    { key: "module", label: <Caption1> Module </Caption1> },
    { key: "activity", label: <Caption1> Activity </Caption1> },
    { key: "initiated_by", label: <Caption1> Initiated by </Caption1> },
    { key: "action", label: <Caption1> Action </Caption1> },
    // { key: "status", label: <Caption1> Status </Caption1> },
  ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          <Button disabled={loading} shape="circular" appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setRefresh(true); setLoading(true) }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <ArrowClockwise20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        <StackItem>
          {permissions.includes("all") || permissions.includes("activityLog_Fullaccess") || permissions.includes("activityLog_ReadandExport") ? (
            <>
              <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_devices_activitylog.csv`}>
              </CSVLink>
              <Button disabled={loading || tableData.length === 0} shape="circular" appearance="subtle" size="small" onClick={() => setExportBtnClicked(true)}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <ArrowDownload20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} /> </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button>
            </>
          ) :
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          }
        </StackItem>

        {/* <StackItem>
          <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{childrenGap:5}} horizontal>
              <StackItem> <Settings20Regular {...primaryIcon}/> </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem> */}
        
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here

  var tempTableData: any = [];
  var menuLists: any = [];

  useEffect(() => {
    var tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      if (val.pageName !== 'Devices') {
        tempExportData.push({
          // Date: new Date(val.time * 1000).toLocaleString(),
          'Date': val.time ? convertToExcelFormat(val.time) : "-",
          Module: val.pageName,
          Activity: JSON.parse(val?.activity)?.summary,
          'Initiated By': val.initiatedBy,
          Action: val.action,
          Status: val.status,
        });
      }
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];
      const newUniqueModule: string[] = [];
      const newUniqueAction: string[] = [];
      const newUniqueStatus: string[] = [];

      final_data.forEach((val: any) => {
        if (val.initiatedBy && val.initiatedBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.initiatedBy)) {
          newUniqueCreatedBy.push(val.initiatedBy);
        }
        if (val.pageName && val.pageName.trim() !== "-" && !newUniqueModule.includes(val.pageName)) {
          newUniqueModule.push(val.pageName);
        }
        if (val.action && val.action.trim() !== "-" && !newUniqueAction.includes(val.action)) {
          newUniqueAction.push(val.action);
        }
        if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
          newUniqueStatus.push(val.status);
        }
      });
      // Set the unique values for each filter category
      setUniqueCreatedBy(newUniqueCreatedBy);
      setUniqueModule(newUniqueModule);
      setUniqueAction(newUniqueAction);
      setUniqueStatus(newUniqueStatus);
    } else {
      setUniqueCreatedBy([]);
      setUniqueModule([]);
      setUniqueAction([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here
    console.log("final_data=", final_data);

    final_data !== undefined && final_data !== null
      ? final_data.map((val: any, i: any) => {
        var activityVal = JSON.parse(val?.activity)?.summary;

        if (val.pageName !== 'Devices') {
          {
            permissions.includes("all") || permissions.includes("activityLog_ReadandExport")  ?
              tempTableData.push({
                id: val.ID,
                checkbox: "hide",
                date: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setOverlayOpen(true); setOverlayData(val); setActivity(JSON.parse(val.activity)); }}> {val.time ? convertUTCToReadableFormat(val.time) : ''} </Button>, id: `${i}` },
                date_timezoned: { label: <Caption1>  {val.time ? convertToLocalTimezone(val.time, userTimeZone) : ''} </Caption1>, id: `${i}` },
                page: { label: <Caption1> {val.pageName} </Caption1>, status: "" },
                activity: { label: <Caption1> {activityVal} </Caption1> },
                initiated_by: { label: <Caption1> {val.initiatedBy} </Caption1> },
                action: { label: <Caption1> {val.action} </Caption1> },
                status: { label: <Caption1> {val.status} </Caption1> },
              }) :
              tempTableData.push({
                id: val.ID,
                checkbox: "hide",
                date: {
                  label: <TooltipHost content="You do not have access">
                    <Button  style={buttonContent} appearance="transparent" size="small" > {val.time ? new Date(val.time * 1000).toLocaleString() : ''} </Button>
                  </TooltipHost>, id: `${i}`
                },
                page: { label: <Caption1> {val.pageName} </Caption1>, status: "" },
                activity: { label: <Caption1> {activityVal} </Caption1> },
                initiated_by: { label: <Caption1> {val.initiatedBy} </Caption1> },
                action: { label: <Caption1> {val.action} </Caption1> },
                status: { label: <Caption1> {val.status} </Caption1> },
              })
          }
        }
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
      if (isRefresh) {
        console.log("FIRST CALL");
        setRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
        setRefreshToast(false);
        }, 3000);
      }
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  useEffect(() => {
    var data = '';

    data = `Activity
            \nDate and time of activity - ${overlayData?.time ? new Date(overlayData?.time * 1000).toLocaleString() : ''}
            \nModule where the activity was performed - ${overlayData?.pageName}
            \nActivity - ${activity?.summary}
            \nInitiated by - ${overlayData?.initiatedBy}
            \nAction - ${overlayData?.action}
            \nStatus - ${overlayData?.status}`;

    if (overlayData?.pageName === "Overview") {
      if (overlayData?.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Device Classification") {
      if (overlayData?.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nClassification name - ${activity.name}
                \nOperation type - ${activity.type}
                \nTotal number of devices added - ${activity.deviceCnt}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData?.action === 'Delete') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nClassification name - ${activity.classificationNames}`;
      } else if (overlayData?.action === 'Create') {
        data += `\n----------------------------------------
        \nTarget
        \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nClassification name - ${activity.classificationNames}`;
      } else if (overlayData?.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Remediation list") {
      if (overlayData?.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Remediation assignment") {
      if (overlayData?.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData?.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nRemediation name - ${activity.remediationName}
                \nAttached scope - ${activity.attachedGroups}
                \nDetached scope - ${activity.detachedGroups}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "User Survey list") {
      if (overlayData.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "User Survey assignment") {
      if (overlayData.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nSurvey name - ${activity.surveyName}
                \nAttached devices list - ${activity.attachedGroups}
                \nDetached devices list - ${activity.detachedGroups}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Compliance Policies list") {
      if (overlayData.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Compliance Policies assignment") {
      if (overlayData.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nCompliance Policies name - ${activity.remediationName}
                \nAttached devices list - ${activity.attachedGroups}
                \nDetached devices list - ${activity.detachedGroups}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Conditional Access list") {
      if (overlayData.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Conditional Access assignment") {
      if (overlayData.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nConditional Access name - ${activity.remediationName}
                \nAttached devices list - ${activity.attachedGroups}
                \nDetached devices list - ${activity.detachedGroups}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
      // }
      //  else if (overlayData?.pageName === "Data Collection list") {
      //   if (overlayData.action === 'Export') {
      //     data += `\n----------------------------------------
      //             \nTarget
      //             \nNot applicalble`;

      //     data += `\n----------------------------------------
      //             \nModified Properties
      //             \nNot applicalble`;
      //   }
    } else if (overlayData?.pageName === "Data Collection assignment") {
      if (overlayData.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nData Collection name - ${activity.remediationName}
                \nAttached devices list - ${activity.attachedGroups}
                \nDetached devices list - ${activity.detachedGroups}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Monitor list") {
      if (overlayData?.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    } else if (overlayData?.pageName === "Monitor assignment") {
      if (overlayData?.action === 'Export') {
        data += `\n----------------------------------------
                \nTarget
                \nNot applicalble`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      } else if (overlayData?.action === 'Add') {
        data += `\n----------------------------------------
                \nTarget
                \nRemediation name - ${activity.remediationName}
                \nAttached scope - ${activity.attachedGroups}
                \nDetached scope - ${activity.detachedGroups}`;

        data += `\n----------------------------------------
                \nModified Properties
                \nNot applicalble`;
      }
    }

    setActivityExportData(data);
  }, [overlayData]);


  //overlay code starts here
  var overLayData: any = {
    headerTitle:
      (
        <>
          <Stack>
            <Text size={600} weight="semibold"> Audit Log Details </Text>
          </Stack>
        </>
      ),
    size: "large",
    isTabs: true,
    tabItems: {
      Activity:
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Date and time of activity (UTC) </Body1Strong> - <Caption1> {overlayData?.time ? new Date(overlayData?.time * 1000).toLocaleString() : ''} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Date and time of activity ({userTimeZone})</Body1Strong> - <Caption1> {overlayData?.time ? convertToLocalTimezone(overlayData?.time, userTimeZone) : ''} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Module where the activity was performed  </Body1Strong> - <Caption1>{overlayData?.pageName}</Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Activity </Body1Strong> - <Caption1>{activity?.summary}</Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Initiated By </Body1Strong> - <Caption1>{overlayData?.initiatedBy}</Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Action </Body1Strong> - <Caption1>{overlayData?.action}</Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Status </Body1Strong> - <Caption1>{overlayData?.status}</Caption1>
            </StackItem>

          </Stack>
        </FluentProvider>
    },
    Targets: '',
    "Modified Properties": '',
    footerData:
      (
        <>
          <FileDownloadComponent data={activityExportData} fileName="Activity_log" />
        </>
      )
  };
  //overlay code ends here

  if (overlayData?.pageName === "Overview") {
    overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
      <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
        <StackItem>
          Not applicalble
        </StackItem>
      </Stack>
    </FluentProvider>

    overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
      <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
        <StackItem>
          Not applicalble
        </StackItem>
      </Stack>
    </FluentProvider>

  } else if (overlayData?.pageName === "Device Classification") {
    if (overlayData?.action === 'Add') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Classification name </Body1Strong> - <Caption1> {activity.name} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Operation type </Body1Strong> - <Caption1> {activity.type} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Total number of devices added </Body1Strong> - <Caption1> {activity.deviceCnt} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> List of devices added </Body1Strong> - <Button shape="circular" size="small" onClick={() => { localStorage.setItem('classificationName', activity.name); navigate("/manage/devices/device_classification/devices") }}> Click here </Button>
            </StackItem>
          </Stack>
        </FluentProvider>

      // if(overlayData?.action === 'Delete'){
      //   overLayData.tabItems['Modified Properties'] = 
      //   <FluentProvider theme={dashboardTheme}>
      //     <Stack tokens={{childrenGap:15, padding:10}}>
      //       <DataTable tableData={JSON.parse(overlayData.activity).deviceList.split(",").map((val: any, i: any) => {return (
      //         { id: i,
      //           checkbox: "hide",
      //           deviceName: {label: <Caption1> {val} </Caption1>, icon: "", status: ""}
      //         }
      //       )})}
      //       columns={[{ key: "deviceName", label: <Body1Strong> Device Name </Body1Strong>}]} />
      //     </Stack> 
      //   </FluentProvider>
      // }
      overLayData.tabItems['Modified Properties'] =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>
    } else if (overlayData?.action === 'Delete') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Classification name </Body1Strong> - <Caption1> {activity.classificationNames} </Caption1>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems['Modified Properties'] =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              Not applicalble
            </StackItem>
          </Stack>
        </FluentProvider>
    } else {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Devices") {
    if (overlayData.action === 'Edit') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Classification name </Body1Strong> - <Caption1> {activity.name} </Caption1>
            </StackItem>

            {activity.type && <StackItem>
              <Body1Strong> Operation type </Body1Strong> - <Caption1> {activity.type} </Caption1>
            </StackItem>}

            <StackItem>
              <Body1Strong> Total number of devices modified </Body1Strong> - <Caption1> {activity.deviceCnt} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> List of devices </Body1Strong> - <Button shape="circular" size="small" onClick={() => { localStorage.setItem('classificationName', activity.name); contextValue.setSelectedRowDetails({ ...contextValue.selectedRowDetails, name: activity.name }); navigate("/manage/devices/device_classification/devices") }}> Click here </Button>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems['Modified Properties'] =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={JSON.parse(overlayData.activity).deviceList.split(",").map((val: any, i: any) => {
              return (
                {
                  id: i,
                  checkbox: "hide",
                  deviceName: { label: <Caption1> {val} </Caption1>, icon: "", status: "" }
                }
              )
            })}
              columns={[{ key: "deviceName", label: <Body1Strong> Device Name </Body1Strong> }]} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No Results</Text></StackItem></Stack>}
          </Stack>
        </FluentProvider>
    } else {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems['Modified Properties'] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Remediation list") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Remediation assignment") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    } else if (overlayData.action === 'Add') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Remediation name </Body1Strong> - <Caption1> {activity.remediationName} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Attached scope </Body1Strong> - <Caption1> {activity.attachedGroups} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Detached scope </Body1Strong> - <Caption1> {activity.detachedGroups} </Caption1>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "User Survey list") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "User Survey assignment") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    } else if (overlayData.action === 'Add') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Survey name </Body1Strong> - <Caption1> {activity.surveyName} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Attached devices list </Body1Strong> - <Caption1> {activity.attachedGroups} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Detached devices list </Body1Strong> - <Caption1> {activity.detachedGroups} </Caption1>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Compliance Policies list") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Compliance Policies assignment") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    } else if (overlayData.action === 'Add') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Compliance Policies name </Body1Strong> - <Caption1> {activity.remediationName} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Attached scope </Body1Strong> - <Caption1> {activity.attachedGroups} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Detached scope </Body1Strong> - <Caption1> {activity.detachedGroups} </Caption1>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Conditional Access list") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Conditional Access assignment") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    } else if (overlayData.action === 'Add') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Conditional Access name </Body1Strong> - <Caption1> {activity.remediationName} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Attached scope </Body1Strong> - <Caption1> {activity.attachedGroups} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Detached scope </Body1Strong> - <Caption1> {activity.detachedGroups} </Caption1>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Data Collection list") {
    // if (overlayData.action === 'Export') {
    //   overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
    //     <Stack tokens={{ childrenGap: 15, padding: 10 }}>
    //       <StackItem>
    //         Not applicalble
    //       </StackItem>
    //     </Stack>
    //   </FluentProvider>

    //   overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
    //     <Stack tokens={{ childrenGap: 15, padding: 10 }}>
    //       <StackItem>
    //         Not applicalble
    //       </StackItem>
    //     </Stack>
    //   </FluentProvider>
    // }
  } else if (overlayData?.pageName === "Data Collection assignment") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    } else if (overlayData.action === 'Add') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Data Collection name </Body1Strong> - <Caption1> {activity.remediationName} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Attached scope </Body1Strong> - <Caption1> {activity.attachedGroups} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Detached scope </Body1Strong> - <Caption1> {activity.detachedGroups} </Caption1>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "Monitor list") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  } else if (overlayData?.pageName === "monitor assignment") {
    if (overlayData.action === 'Export') {
      overLayData.tabItems.Targets = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    } else if (overlayData.action === 'Add') {
      overLayData.tabItems.Targets =
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Body1Strong> Remediation name </Body1Strong> - <Caption1> {activity.remediationName} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Attached scope </Body1Strong> - <Caption1> {activity.attachedGroups} </Caption1>
            </StackItem>

            <StackItem>
              <Body1Strong> Detached scope </Body1Strong> - <Caption1> {activity.detachedGroups} </Caption1>
            </StackItem>
          </Stack>
        </FluentProvider>

      overLayData.tabItems[`Modified Properties`] = <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
          <StackItem>
            Not applicalble
          </StackItem>
        </Stack>
      </FluentProvider>
    }
  }

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem> <Text></Text> </StackItem>
                <StackItem grow shrink>
                  {/* <Breadcrumbs pageName="Devices" subPageName="" subPageLink="#" /> */}
                  <Breadcrumbs 
                      items={[
                        { name: "Manage", link: "/home" },
                        { name: "Devices", link: "/manage/devices/overview" },
                        { name: "Activity Log", link: "#" }
                      ]} 
                    />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                <StackItem> <Text></Text> </StackItem>
                <StackItem>
                  <FluentProvider theme={dashboardTheme}>
                    <Title3> Devices | Activity Log </Title3>
                  </FluentProvider>
                </StackItem>
              </Stack> */}
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal >
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={DevicesPages("Activity Log")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Module"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0}/>
                             </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn=
                                  {
                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <Filter20Filled {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={
                                    <>
                                      <Body1Strong> Add a Filter </Body1Strong>
                                      <Divider />
                                      <MenuList>
                                        <Stack tokens={{ childrenGap: 5 }}>
                                          <StackItem> <Text></Text> </StackItem>
                                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                          <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                          <StackItem> <Divider /> </StackItem>
                                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                                          {(dropDownValue1 === 'Date') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                          {/* {(dropDownValue1 === "Activity") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />} */}
                                          {dropDownValue1 === "Activity" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />))}
                                          {dropDownValue1 === "Initiated by" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={createdByOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          {dropDownValue1 === "Module" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={moduleOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          {dropDownValue1 === "Action" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={actionOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          {dropDownValue1 === "Status" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={statusOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                          <StackItem> <Divider /> </StackItem>
                                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <StackItem>
                                              <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                <Caption1> Apply </Caption1>
                                              </Button>
                                            </StackItem>

                                            <StackItem>
                                              <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                <Caption1> Cancel </Caption1>
                                              </Button>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      </MenuList>
                                    </>
                                  }
                                />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled} >
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 &&
                                // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                <Stack wrap horizontal >
                                  {filterArray.length > 0 && filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                  {/* </Stack> */}
                                </Stack>}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <InfoBar showSpaces={true} title={"Logs for activities performed in the Devices module."} />

                      </StackItem>

                      <Activity_log_func data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} type="getLog" moduleName="Devices" setExportDetails={setExportDetails} setRefresh={setRefresh} isRefresh={isRefresh} setRefreshToast={setRefreshToast} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} filterArray={filterArray} />
                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                      {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={overLayData} />
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};